export const clientName = (client) => {
  if (!client) return "";
  if (client.type?.toLowerCase() === "company") return client.company_name || "";
  return `${client.primary_user?.first_name || ""} ${client.primary_user?.last_name || ""}`.trim();
};

export const personName = (person) =>
  person ? `${person.first_name || ""} ${person.last_name || ""}`.trim() : "";

export const formatDateTime = (date) =>
  date
    ? new Date(date).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

export const formatMoney = (value) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatLanguagePair = (lp) =>
  lp ? `${lp.sourceLanguage?.name || "?"} → ${lp.targetLanguage?.name || "?"}` : "";

export const toLocalInput = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};